import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { timeThursdays } from 'd3';
import { Message, MessageService } from 'primeng/api';
import { cloneDeep, conformsTo, findIndex, method } from 'lodash';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';


@Component({
  selector: 'app-add-project',
  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.scss', '../../../../../mystery-shopper/mystery-shopper.component.scss'],
  providers: [MessageService]
})
export class AddProjectComponent {
  header: string = this.translate("Add Project");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    },
    {
      name: this.translate('Vendor'),
      icon: 'pi pi-plus',
      link: '/ms/vendor',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
  ];

  addUserBreadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
  ]

  //Notificaitons
  messages: Message[] = [];

  //Update
  oldProject: any;
  isUpdate: boolean = false;

  //API
  skelition: boolean = false;

  //Project Data
  externalVendors: any[] = [];
  internalPm: any[] = [];
  project: any = {};
  goalText: string = '';
  updateGoalText: string = '';

  //Channel Data
  channelNameText: string = '';
  updateChannelNameText: string = '';
  selectedChannels: any[] = [{ name: 'Branches', visitCount: 0 }];
  channels: any[] = [{ name: 'Branches', visitCount: 0 }];

  //msc
  editGoalIndex: number = -1;
  minDate: Date = new Date();
  channelErrorTest: string = '';
  addedUsers: any[] = [];
  senior: any;

  //Modals
  showAddChannel: boolean = false;
  showAddUserModal: boolean = false;
  selectedBranches: any[] = [];
  selectedVendor: any;
  selectedInternalPM: string = "";

  allTags: string[] = [];
  allowedTags: string[] = this.permissionService.extractTags('MYSTERY_SHOPPER_TAGS', 'r')

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private messageService: MessageService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    this.getInternalVendors();
    this.getVendors();
    this.getMSTags();
    this.route.params.subscribe(params => {
      let id = params['id'];
      if (id) {
        this.getProject(id).then(() => {
          console.log("this.project",this.project);
          console.log("this.project.responsibles",this.project.responsibles);
          if (this.project.responsibles)
          {
            this.addedUsers = this.project.responsibles.map((r: any) => {
              if (r.isSenior) {
                this.senior = r.user._id;
              }
              return r.user._id;
            })
          }
        })
        this.isUpdate = true;
        this.header = this.translate("Update Project");
        this.breadcrumbs.push({ name: this.translate('Update Project'), link: '/ms/project/update/' + id });
        this.addUserBreadcrumbs.push(
          { name: this.translate('Update Project'), link: '/ms/project/update/' + id },
          { name: this.translate('MS Add Responsible'), link: '/ms/project/update/' + id }
        );

      } else {
        this.skelition = false;
        this.breadcrumbs.push({ name: this.translate('Add Project'), link: '/ms/project/add' });
        this.addUserBreadcrumbs.push(
          { name: this.translate('Add Project'), link: '/ms/project/add' },
          { name: this.translate('MS Add Responsible'), link: '/ms/project/add/' + id }
        );
      }
    })
  }

  changeTopData(){
    this.links = [
      {
        name: this.translate('Back'),
        icon: 'pi pi-refresh',
        link: '/ms/project',
      }
    ];
    this.showAddUserModal = true;
  }

  seniorChange(event: any) {
    this.project.responsibles = this.project.responsibles.map((e: any) => {
      if (e.user._id == event.value) {
        e.isSenior = true;
      } else {
        e.isSenior = false;
      }
      return e;
    })
    console.log(this.project.responsibles);
  }

  addResponsibles(data: any) {
    if (data.emit) {
      this.addedUsers = [];
      this.project.responsibles = data.users.map((e: any) => {
        this.addedUsers.push(e._id);
        let data = {
          user: e,
          isSenior: !this.senior ? true : false
        }
        if (!this.senior) {
          this.senior = e._id;
        }
        return data;
      })
    }
    this.showAddUserModal = false;
    this.links = [
      {
        name: this.translate('Back'),
        icon: 'pi pi-refresh',
        link: '/ms/project',
      },
      {
        name: this.translate('Vendor'),
        icon: 'pi pi-plus',
        link: '/ms/vendor',
      },
    ];
    console.log(this.project.responsibles);
  }

  removeResponsible(index: number) {
    let removed = this.project.responsibles.splice(index, 1);
    if (removed) {
      this.addedUsers = this.addedUsers.filter(e => e == removed[0].user._id);
      if (removed[0].user._id == this.senior && this.project.responsibles.length != 0) {
        let newSenior = this.project.responsibles[0];
        newSenior.isSenior = true;
        this.senior = newSenior.user._id;
      } else {
        this.senior = null;
      }
    }
    if (this.project.responsibles.length == 0) {
      this.senior = null;
    }
  }

  convertResponsiblesToIds() {
    this.project.responsibles = this.project.responsibles.map((r: any) => {
      r.user = r.user._id;
      return r;
    })
  }

  numberOnly(event: any, limit:boolean): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    
    // Allowing decimal point (ASCII 46) and numbers (ASCII 48-57)
    if ((charCode !== 46 && charCode !== 45 && charCode > 31 && (charCode < 48 || charCode > 57)) ||
        (event.target.value.includes('.') && charCode === 46)) {
      return false;
    }
    
    // Check if the input value exceeds 5
    const inputValue = event.target.value + event.key;
    if (parseFloat(inputValue) > 5 && limit) {
      return false;
    }
    
    return true;
  }


  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.oldProject = res.data.data;
      this.oldProject.startDate = new Date(this.oldProject.startDate);
      this.oldProject.endDate = new Date(this.oldProject.endDate);
      this.oldProject.vendor = this.oldProject.vendor.map((e: any) => e._id)
      this.oldProject.internalPm = this.oldProject.internalPm._id;
      this.project = this.oldProject;
      
      this.channels = res.data.channels.filter((item:any)=> item.type =='Basic')
      this.selectedBranches = res.data.channels.filter((item:any)=> item.type =='Branch')
      this.selectedChannels = cloneDeep(this.channels);
      this.skelition = false;
    } catch (e: any) {

      console.log("Error :", e)
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async createSession(projectId:string) {
    try {
      let startDate = new Date(this.project.startDate);
      let endDate = new Date(this.project.endDate);
      let session = {
        startDate: startDate,
        endDate: endDate,
        projectId: projectId,
        visits: {
          approvalStatus: 'Pending',
          comments: "",
          data: []
        }
      }
      let res = await this.dataService.postData('ms-sessions', session);
      if (res.error) return
    } catch (error) {
      console.log(error)
    }
  }

  async getInternalVendors() {
    try {
      this.skelition = true;
      let res = await this.dataService.getData('user/vendors')
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.internalPm = res.data;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getVendors() {
    try {
      this.skelition = true;
      let res = await this.dataService.getData('ms-vendor-company')
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.internalPm = res.data.filter((i: any) => i.classification == "internal");
      this.externalVendors = res.data;
      console.log("this.externalVendors",this.externalVendors);
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  extractUsername(name: any) {
    if (name) {
      return name.first + ' ' + name.middle + ' ' + name.last;
    }
    return ''
  }

  extractSelectedVendorName(vendors: any[], field: string) {
    return this.extractUsername(vendors.find(v => v._id == this.project[field])?.email)
  }

  extractSelectedVendorCompany(vendors: any[], field: string) {
    return vendors.find(v => v._id == this.project[field])?.vendorExtraDetails?.companyName
  }
  
  addGoal() {
    if (this.goalText) {
      if (this.project.goal) {
        this.project.goal = [...this.project.goal, this.goalText];
      } else {
        this.project.goal = [this.goalText];
      }
    }
    this.goalText = '';
  }

  deleteGoal(i: number) {
    this.project.goal.splice(i, 1)
    this.project = this.project;
  }

  updateGoal() {
    let goal = this.project.goal;
    goal[this.editGoalIndex] = this.updateGoalText;
    this.updateGoalText = '';
    this.editGoalIndex = -1;
  }

  addChannel() {
    if (this.channelNameText) {
      let present = this.channels.findIndex(c => c.name == this.channelNameText) !== -1;
      if (!present) {
        this.channels = [...this.channels, { name: this.channelNameText, visitCount: 0 }]
        this.selectedChannels.push({ name: this.channelNameText, visitCount: 0 })
        this.showAddChannel = false;
        this.channelNameText = '';
        this.channelErrorTest = '';
      } else {
        this.channelErrorTest = this.translate('Channel with this name already exists');
      }
    }
  }

  addRemoveChannel(channel: any) {
    if (this.channelSelected(channel)) {
      let index = this.selectedChannels.findIndex(c => c.name == channel.name);
      this.selectedChannels.splice(index, 1);
    } else {
      this.selectedChannels.push(channel);
    }
    this.selectedChannels = this.selectedChannels;
  }

  channelSelected(channel: any) {
    return this.selectedChannels.findIndex(c => c.name == channel.name) !== -1;
  }

  async createProject() {
    try {
      if (this.project.responsibles == undefined || this.project.responsibles == null || this.project.responsibles.length == 0) {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate("Please select at least 2 responsibles") 
        });
        return;
      }

      if (this.project.vendorCompanyId == undefined || this.project.vendorCompanyId == null || this.project.vendorCompanyId == "") {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate("Please Select External PM") 
        });
        return;
      }

      if (this.project.internalPMEmail == undefined || this.project.responsibles == null || this.project.internalPMEmail == "") {
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate("Please Enter Internal PM Email") 
        });
        return;
      }

      const selectedIPM = this.internalPm.find((i: any) => i.email === this.project.internalPMEmail);

      console.log("selectedIPM",selectedIPM);
      if (!selectedIPM){
        this.messageService.add({ 
          severity: 'error', summary: this.translate('error'), detail: this.translate("Internal PM does not Exist with this Email") 
        });
        return;
      }
      this.skelition = true;
      this.project.internalPm = selectedIPM._id;
      const selectedVendor = this.externalVendors.find((i: any) => i._id === this.project.vendorCompanyId);
      this.project.vendor  = selectedVendor ? selectedVendor.vendors : [];
      this.convertResponsiblesToIds();
      let res = await this.dataService.postData('ms-project', this.project, this.isUpdate ? 'PUT' : 'POST');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      console.log(res.data)
      this.createChannel(res.data._id);
      if (!this.isUpdate)
      {
        this.createSession(res.data._id)
      }
    } catch (e) {
      console.log(e);
    }
  }

  updateChannelCount(channel: any) {
    let sChannel = this.selectedChannels.findIndex(c => c.name == channel.name);
    if (sChannel !== -1) {
      this.selectedChannels[sChannel].visitCount = Number(channel.visitCount);
    }
    console.log(this.selectedChannels);
  }

  async createChannel(projectId: string) {
    try {
      let data: any[] = [];
      this.selectedChannels.forEach((channel: any) => {
          let channelData: any = {
              _id: channel._id || null,
              name: channel.name,
              projectId: projectId,
              visitCount: channel.visitCount || 0,
              type: "Basic",
              weight: channel.weight || 0
          };
          data.push(channelData);
      });
      this.selectedBranches.forEach((branch: any) => {
          let branchData: any = {
              _id: branch._id || null,
              name: branch.name,
              projectId: projectId,
              branchId: branch.branchId || branch._id,
              visitCount: branch.visitCount || 0,
              type: "Branch",
              weight: branch.weight || 0
          };
          data.push(branchData);
      });


      let res = await this.dataService.postData('ms-channel/many', data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.router.navigate(['/ms/project'])
    } catch (e) {
      console.log(e);
    }
  }

  async getMSTags() {
    console.log("allowedTags",this.allowedTags);
    try {
      let res = await this.dataService.getData('survey-tags/MS');
      if (res.error) {
        return;
      }
      if (this.allowedTags.includes('MASTER_TAG')) {
        this.allTags = res.data.filter((e: any) => e.tag != 'MASTER_TAG').map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            value: data.tag
          }
        });
      } else {
        this.allTags = res.data.filter((e: any) => this.allowedTags.includes(e.tag)).map((data: any) => {
          return {
            _id: data._id,
            label: data.arabic,
            value: data.tag
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
}
